import { render, staticRenderFns } from "./PartnerForm.vue?vue&type=template&id=5358ce65&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./PartnerForm.vue?vue&type=script&lang=ts"
export * from "./PartnerForm.vue?vue&type=script&lang=ts"
import style0 from "./PartnerForm.vue?vue&type=style&index=0&id=5358ce65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5358ce65",
  null
  
)

export default component.exports